import React from 'react';
import '../styles/layout/WorkplaceSafety.css'
import { Container, Row, Col } from 'react-bootstrap';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import EastRoundedIcon from '@mui/icons-material/EastRounded';

const DOCUMENTS = [
  { href: '/documents/Posh.pdf', label: 'POSH@WORK' },
  { href: '/documents/Equal.pdf', label: 'Equal Opportunity Policy' },
]

const PrivacyPolicies = () => {
  return (
    <div className='policy'>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <h1>Workplace Safety</h1>
            <span className="rule" />
            <ul className="policy__list">
              {DOCUMENTS.map(({ href, label }) => (
                <li key={href}>
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    <span className="policy__icon" aria-hidden="true">
                      <PictureAsPdfOutlinedIcon />
                    </span>
                    <span className="policy__label">{label}</span>
                    <EastRoundedIcon className="policy__arrow" fontSize="small" />
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PrivacyPolicies;
